import * as React from 'react';
import { ILinksData } from '../farmlands-promotion-block.props.autogenerated';

export interface IFarmlandsPromotionBlockButton {
    buttons: ILinksData[];
}

const FarmlandsPromotionBlockButton: React.FC<IFarmlandsPromotionBlockButton> = ({ buttons }) => (
    <>
        {buttons.map((button: ILinksData, index: number) => {
            return (
                <div
                    className={`farmlands-promotion-block__button ${
                        index === 0
                            ? 'farmlands-promotion-block__button--primary'
                            : 'farmlands-promotion-block__button--secondary'
                    }`}
                    key={`button-${index}`}
                >
                    <a
                        role='button'
                        title={button.linkText}
                        aria-label={button.ariaLabel}
                        href={button.linkUrl.destinationUrl}
                    >
                        {button.linkText}
                    </a>
                </div>
            );
        })}
    </>
);

export default FarmlandsPromotionBlockButton;
